// extracted by mini-css-extract-plugin
export default {"description":"style_description__SjU-5","fade-in":"style_fade-in__9YTzN","top":"style_top__WQKnh","image":"style_image__2XZqq"};